

import './index.scss'
import { callAPIForQuery } from '../../utilities/service'
import { useState } from 'react'
import { Loader } from '../common/Loader'
import WebRTCComponentWithChatAndVideo from './Video/WebRTCComponentWithChatAndVideo'
import toast, { Toaster } from 'react-hot-toast'
import { ToastPanel } from '../common/ToastPanel'
import { TOAST } from '../../utilities/constant'
import WebRTCONETOONEComponent from './Video/WebRTCONETOONEComponent'
export const HIS = ({ role_id, user_name, user_id, appointment_id, vechile_no, sectionCount }: any) => {
    const [loading, setLoading] = useState(false);
    const [hideVideoStream, setHideVideoStream] = useState(false);
    const [sourceId, setSourceId] = useState<any>();
    const [destinationId, setDestinationId] = useState<any>();
    const [isHost, setHost] = useState<any>(null)
    const join = async (is_host: number) => {
        const payload = `{
            "appointment_id": "${appointment_id}",
            "tracking_id": "${sourceId}",
            "created_by": ${user_id},
            "is_host":${is_host}
            }`;
        setLoading(true)
        const result: any = await callAPIForQuery({ input: payload, type: 'insert_his_track' }, 'post', true)
        setLoading(false)

        if (!result.error) {
            toast.error(<ToastPanel message={`You have joined as ${is_host ? "host" : " participant"}. Please wait for few seconds to receive the remote video `} />, TOAST)
            // alert(`You have joined as ${is_host ? "host" : " participant"}. Please wait for few seconds to receive the remote video `);
            setDestinationId(result[0][0].tracking_id)
            setHost(is_host)
        } else {
            toast.error(<ToastPanel message={result.error} />, TOAST)
        }
    }
    return <div className="his-main">
        <Toaster position="bottom-right" />
        {(loading || hideVideoStream) && <Loader />}
        <div className="row">
            <div className='col-lg-6'>
                <div className='action-set'>
                    {isHost === null && sourceId && (<>
                        {role_id === 3 && (<input type="button" value="Join as Host" onClick={() => join(1)} />)}
                        {role_id === 4 && (<input type="button" value="Join as Participant" onClick={() => join(0)} />)}
                    </>
                    )}
                    <input type="button" value="Reconnect" onClick={async () => {
                        setDestinationId(null);
                        setSourceId(null);
                        setHost(null)
                        setHideVideoStream(true)
                        const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

                        await sleep(5000)
                        setHideVideoStream(false)

                    }
                    } />
                    <input type="button" value="Refresh" onClick={async () => {
                        const payload = `{
                                                "tracking_id": "${sourceId}"
                                                }`;
                        const result: any = await callAPIForQuery({ input: payload, type: 'get_his_track' }, 'post', true);
                        if (result.error) toast.error(<ToastPanel message={result.error} />, TOAST)

                    }
                    } />
                </div>

                {!hideVideoStream && (<WebRTCComponentWithChatAndVideo loggedInUser={user_name} sourceId={sourceId} onTrackIDGenerate={setSourceId} destinationId={destinationId} />)}

            </div>
            <div className='col-lg-6'>
                <WebRTCONETOONEComponent userId={user_id} loggedInUser={user_name} />
            </div>
        </div>
        <br />
        {/* <ECGChart /> */}
        {/* <div className='row'>
            {createNumericArray(sectionCount).map((opt: any) => {
                return (<div className='col-lg-6'>
                    <div className='section'>
                        <div className='content'>
                        </div>
                    </div>
                </div>)
            })}
        </div> */}
    </div>
}